<script setup>
const props = defineProps({
  caption: {
    type: String,
    required: true,
  },

  align: {
    type: String,
    default: 'start',
    validator(value) {
      return ['start', 'end'].includes(value);
    },
  },
});

const { $tp } = useNuxtApp();
</script>

<template>
  <div class="ui-caption-underline">
    <div
      class="ui-caption-underline__caption"
      :class="{
        [`ui-caption-underline__caption--align--${props.align}`]: props.align,
      }"
    >
      <span
        class="ui-caption-underline__font ui-caption-underline__font--caption"
      >
        {{ $tp(props.caption) }}
      </span>
    </div>

    <CSpriteIcon
      align="end"
      name="map_border_bullet"
      class="ui-caption-underline__icon ui-caption-underline__icon--border"
    />
  </div>
</template>

<style scoped lang="scss">
.ui-caption-underline {
  &__font {
    display: block;

    &--caption {
      font-size: em(10);
      font-weight: 800;
      line-height: 100%;

      @include media-breakpoint-down(md) {
        font-size: em(8);
      }

      @include media-breakpoint-down(sm) {
        font-size: em(10);
      }
    }
  }

  &__icon {
    &--border {
      width: em(100);
      height: em(4);

      @include media-breakpoint-down(md) {
        width: em(80);
      }

      @include media-breakpoint-down(sm) {
        width: em(100);
      }
    }
  }

  &__caption {
    width: 100%;
    margin-bottom: em(5);
    color: $color-white;
    text-transform: uppercase;

    @include media-breakpoint-down(md) {
      margin-bottom: em(3);
    }

    &--align {
      &--start {
        text-align: start;
      }

      &--end {
        text-align: end;
      }
    }
  }
}
</style>
